import styled from 'styled-components'
import { common } from '@ocean/ui'

const { Icon } = common

type RootType = {
  clickable?: boolean
}

export const Root = styled.div<RootType>`
  ${({ clickable }) => clickable && `cursor: pointer;`}
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

export const IconChevron = styled(Icon)`
  width: 14px;
  height: 14px;

  > path {
    stroke: ${({ theme }) => theme.color.oceanLight};
  }

  transform: rotate(-90deg);
`
